"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasStringTranslation = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _getLangLocale = _interopRequireDefault(require("I18n/utils/getLangLocale"));

var _getLang = _interopRequireDefault(require("I18n/utils/getLang"));

// This a hacky string util to determine if translations for a string exist
// We can't use I18n.lookup or I18n's isValidI18nKey
// bc those will return true if the English string exists, regardless of if the translation exists
var hasStringTranslation = function hasStringTranslation(stringKey) {
  var keys = stringKey.split('.');

  var lookupStringByLangCode = function lookupStringByLangCode(langCode) {
    var stringPath = _I18n.default.translations[langCode];
    if (!stringPath) return false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;
        if (!stringPath[key]) return false;
        stringPath = stringPath[key];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return stringPath;
  };

  return !!lookupStringByLangCode((0, _getLangLocale.default)()) || !!lookupStringByLangCode((0, _getLang.default)());
};

exports.hasStringTranslation = hasStringTranslation;


//////////////////
// WEBPACK FOOTER
// ./js/utils/stringUtils.js
// module id = 590
// module chunks = 5 6